module.exports = __webpack_public_path__ + "img/z_y.000e760c.png";